import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import styled from 'styled-components';
import colors from '@theme/colors';
import DateSelector from './DateSelector';

const DatePickerWrapper = styled.div`
  font-size: inherit;
  font-weight: 400;

  .dPeixn label.placeholder {
    color: ${colors.PRIMARY};
  }

  input {
    font-size: inherit;
    font-weight: 400;
  }

  .rdtPicker {
    width: 316px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
    border-radius: 2px;
    padding: 0 8px;

    td,
    th {
      height: 40px;
    }

    th {
      color: ${colors.BLACK};
      font-weight: 400;

      &.dow {
        color: ${colors.DARK_GREY};
        font-size: 12px;
      }

      &.rdtNext,
      &.rdtPrev {
        font-size: 26px;
      }
    }

    td {
      font-size: 12px;

      &.rdtDay {
        border-radius: 50%;
      }

      &.rdtDay,
      &.rdtMonth,
      &.rdtYear {
        color: ${colors.BLACK};
        font-weight: inherit;

        &.rdtToday {
          color: ${colors.PRIMARY};
          position: initial;

          &::before {
            content: none;
          }
        }

        &.rdtActive {
          color: ${colors.WHITE};
          background-color: ${colors.PRIMARY};
        }

        &.rdtOld,
        &.rdtNew {
          visibility: hidden;
        }
      }
    }
  }
`;

const normalize = (callback) => (value) => value && callback(value);

const DatePicker = ({ onChange, ...props }) => (
  <DatePickerWrapper>
    <Datetime
      timeFormat={false}
      closeOnSelect
      onBlur={normalize(onChange)}
      onChange={onChange}
      value={props.value}
      renderInput={DateSelector(props)}
    />
  </DatePickerWrapper>
);

DatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(Date),
  caption: PropTypes.node,
  placeholder: PropTypes.node,
};

DatePicker.defaultProps = {
  caption: '',
  placeholder: '',
};

export default DatePicker;



// WEBPACK FOOTER //
// ./components/atoms/DatePicker/DatePicker.js